import classNames from 'classnames'
import { Crown } from 'iconoir-react'

const NO_SUPER_USER_TABS: string[] = []

export default function DashboardTabs({
  openTab,
  onSetOpenTab,
  tabOptions,
  superUserTabs = NO_SUPER_USER_TABS,
}: {
  openTab: string
  onSetOpenTab: (tab: string) => void
  tabOptions: string[]
  /** Tabs only super users can see; they get the same crown badge as `Tabs` and the sidebar. */
  superUserTabs?: string[]
}) {
  return (
    <div className="relative mt-3" aria-label="Tabs">
      {/* No horizontal padding here: every caller renders this inside
          PageScroll's header slot, which already supplies the px-10 page gutter.
          Adding our own doubled it (80px on desktop) and knocked the tabs out of
          alignment with the PageHeader title. overflow-x-auto only lets the row
          scroll if it ever overflows; it's inert at desktop widths. */}
      <div className="flex space-x-4 overflow-x-auto">
        {tabOptions?.map((tabOption) => (
          <div
            key={tabOption}
            className={classNames(
              openTab === tabOption
                ? `border-b-2 border-solid border-blue-600 text-blue-900`
                : `text-subtle hover:text-default`,
              `z-10 shrink-0 cursor-pointer whitespace-nowrap bg-transparent px-1 pb-4 pt-0.5 text-ui-sm`,
            )}
            onClick={() => onSetOpenTab(tabOption)}
          >
            {/* Drop the "Breakdown" suffix on mobile so the tabs fit without a
                horizontal scrollbar; the full label stays from md up. The tab
                value (openTab) is unchanged — only the display is shortened. */}
            <div className="flex items-center align-middle">
              <span className="md:hidden">{tabOption.replace(/ Breakdown$/, ``)}</span>
              <span className="hidden md:inline">{tabOption}</span>
              {superUserTabs.includes(tabOption) && (
                <div className="size-5 ml-1.5 flex items-center justify-center rounded bg-amber-500/[0.08]">
                  <Crown width={12} height={12} className="text-amber-800" />
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
      <div className="absolute bottom-0 h-[1px] w-full bg-surface-strong"></div>
    </div>
  )
}
